import DigitalStatementInfo from "../components/DigitalStatementInfo";
// import WcagChecklist from "../components/WcagChecklist";

const DigitalAccessability = () => {
  return (
    <>
      <div className="div-odd">
        <DigitalStatementInfo />
      </div>
      {/* <div>
        <WcagChecklist />
      </div> */}

    </>
  );
};

export default DigitalAccessability;
